import { useState } from 'react';

const faqData = [
  {
    q: '17c.com 的官方地址是什么？',
    a: '17c.com 的唯一官方地址是 https://17c.com。我们建议您将该地址添加到浏览器书签中，以便随时访问。请注意辨别仿冒网站，如发现可疑地址请立即向我们举报。',
  },
  {
    q: '访问 17c.com 需要注册账号吗？',
    a: '浏览 17c.com 的公开内容无需注册。如需使用个性化功能（如收藏内容、社区交流等），则需要注册免费账号。注册流程简单快捷，仅需手机号码即可完成。',
  },
  {
    q: '为什么有时候打不开 17c.com？',
    a: '可能的原因包括：网络连接不稳定、浏览器缓存问题、DNS解析异常等。建议您尝试清除浏览器缓存、切换网络环境或使用我们提供的备用入口地址进行访问。',
  },
  {
    q: '17c.com 如何保障用户数据安全？',
    a: '17c.com 采用全站 HTTPS 加密传输，部署多层安全防护体系，并定期进行安全审计。您的个人数据受到严格的隐私保护，我们不会在未经授权的情况下向第三方提供您的信息。',
  },
  {
    q: '如何联系 17c.com 客服？',
    a: '您可以通过以下方式联系我们的客服团队：发送邮件至 support@17c.com、拨打客服热线 400-000-1700，或访问"关于我们"页面查看更多联系方式。客服服务时间为周一至周日 9:00-22:00。',
  },
  {
    q: '17c.com 是否支持移动端访问？',
    a: '是的，17c.com 已全面适配手机和平板等移动设备，自动识别屏幕尺寸并提供最佳浏览体验。您还可以通过浏览器菜单将网站添加到手机主屏幕，像使用 App 一样快速打开。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-primary-50 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            您可能想了解的问题
          </h2>
          <p className="text-foreground-600">
            我们整理了用户最常咨询的问题，帮助您快速找到答案
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100/50 transition-colors cursor-pointer"
              >
                <span className="font-heading text-sm font-semibold text-foreground-900 pr-4">
                  {item.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 text-lg flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}